/*document.querySelector(document).ready(function() {
    document.querySelector(document).addEventListener("submit", "#combo_blog", function (e) {
        e.preventDefault();
        var option1 = document.querySelector('#combo_option_1').value;
        var option2 = document.querySelector('#combo_option_2').value;
        document.querySelector('.comboResults .oneResult.active').classList.remove('active');
        document.querySelector('.comboResults .oneResult#result_'+option1+option2).classList.add('active');
        console.log("option1: "+option1+" and option2: "+option2);
    });
});*/

function submitCombo(event) {

  var option1 = document.getElementById('combo_option_1').value;
  var option2 = document.getElementById('combo_option_2').value;

  document.querySelector('.oneResult.active')?.classList.remove('active');
  
  var new_active = document.getElementById("result_"+option1+option2);
  if(new_active !== null){
    new_active.classList.add('active');
  }
  
  //console.log("option1: "+option1+" and option2: "+option2);
  event.preventDefault();
}

const form = document.getElementById("combo_blog");
if(form !=null){
  form.addEventListener("submit", submitCombo);
}


//compare code
//dropdown 1
function compareOne(event) {
	var option1 = document.getElementById("compare_option_1").value;

	document
		.querySelector(".col1 .oneResult.active")
		?.classList.remove("active");

	var new_active = document.getElementById("result1_" + option1);
	if (new_active !== null) {
		new_active.classList.add("active");
	}

	console.log("option1: " + option1);
	event.preventDefault();
}

const compare_option_1 = document.getElementById("compare_option_1");
if(compare_option_1 !=null){
  compare_option_1.addEventListener("change", compareOne);
}

//dropdown 2
function compareTwo(event) {
	var option2 = document.getElementById("compare_option_2").value;

	document
		.querySelector(".col2 .oneResult.active")
		?.classList.remove("active");

	var new_active = document.getElementById("result2_" + option2);
	if (new_active !== null) {
		new_active.classList.add("active");
	}

	console.log("option2: " + option2);
	event.preventDefault();
}

const compare_option_2 = document.getElementById("compare_option_2");
if(compare_option_2 !=null){
  compare_option_2.addEventListener("change", compareTwo);
}

//dropdown 3
function compareThree(event) {
	var option3 = document.getElementById("compare_option_3").value;

	document
		.querySelector(".col3 .oneResult.active")
		?.classList.remove("active");

	var new_active = document.getElementById("result3_" + option3);
	if (new_active !== null) {
		new_active.classList.add("active");
	}

	console.log("option3: " + option3);
	event.preventDefault();
}

const compare_option_3 = document.getElementById("compare_option_3");
if (compare_option_3 != null) {
	compare_option_3.addEventListener("change", compareThree);
}

//dropdown 4
function compareFour(event) {
	var option4 = document.getElementById("compare_option_4").value;

	document
		.querySelector(".col4 .oneResult.active")
		?.classList.remove("active");

	var new_active = document.getElementById("result4_" + option4);
	if (new_active !== null) {
		new_active.classList.add("active");
	}

	console.log("option4: " + option4);
	event.preventDefault();
}

const compare_option_4 = document.getElementById("compare_option_4");
if (compare_option_4 != null) {
	compare_option_4.addEventListener("change", compareFour);
}
